import { atom, useAtom, useSetAtom } from "jotai";

export type FlyItem = {
  id: string;
  src: string;
  startX: number;
  startY: number;
  endX: number;
  endY: number;
  startSize: number;
  endSize: number;
  enabled?: boolean;
};

export const flyAtom = atom<FlyItem | null>(null as FlyItem);

const useFlyItem = () => {
  return useAtom(flyAtom);
};

export const useSetFlyItem = () => useSetAtom(flyAtom);

export default useFlyItem;
